import React, { useEffect, useState } from 'react';
import { api } from "../../api";
import EditModal from './EditModal';
import Avatar from "../../components/Avatar";
import { formatDate } from '../../utils/formatDate';

function EmployeeList({ reloadFlag }) {
  const [employees, setEmployees] = useState([]);
  const [selected, setSelected] = useState(null);

  const fetchEmployees = async () => {
    try {
      const res = await api.get('/users/assignable');
      setEmployees(res.data.users);
    } catch (err) {
      console.error('Fel vid hämtning av anställda:', err);
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, [reloadFlag]);
    

  return (
    <div className="container mt-4">
      <h2>Anställda – Inpassering</h2>
      <ul className="list-group">
        {employees.map((emp) => {
        const hasSSG  = Boolean(emp.ssgApplied || emp.ssgExpired);
        const hasLKAB = Boolean(emp.lkabApplied || emp.lkabExpired);

        return (
            <li
            key={emp._id}
            className="list-group-item list-group-item-action py-3"
            onClick={() => setSelected(emp)}
            role="button"
            >
            <span className="badge bg-light text-dark">
            <Avatar
                initials={emp.avatar?.initials}
                color={emp.avatar?.color}
                size={18}
            />{" "}
            {emp.firstName}
            </span>

            {hasSSG && (
                <>
                {emp.ssgApplied && (
                    <div className="small text-muted">
                    <strong>SSG – Senaste ansökan:</strong> {formatDate(emp.ssgApplied)}
                    </div>
                )}
                {emp.ssgExpired && (
                    <div className="small text-muted">
                    <strong>SSG – Utgångsdatum:</strong> {formatDate(emp.ssgExpired)}
                    </div>
                )}
                </>
            )}

            {/* Avskiljare visas bara om båda sektionerna finns */}
            {hasSSG && hasLKAB && <div className="border-top my-2 opacity-25" />}

            {hasLKAB && (
                <>
                {emp.lkabApplied && (
                    <div className="small text-muted">
                    <strong>LKAB – Senaste ansökan:</strong> {formatDate(emp.lkabApplied)}
                    </div>
                )}
                {emp.lkabExpired && (
                    <div className="small text-muted">
                    <strong>LKAB – Utgångsdatum:</strong> {formatDate(emp.lkabExpired)}
                    </div>
                )}
                </>
            )}
            </li>
        );
        })}

      </ul>

      {selected && (
        <EditModal
          type="employee"
          item={selected}
          onClose={() => setSelected(null)}
          onUpdate={fetchEmployees}
        />
      )}
    </div>
  );
}

export default EmployeeList;
